import { render, staticRenderFns } from "./VHEWABOY.vue?vue&type=template&id=55fd4c8d&scoped=true"
import script from "./VHEWABOY.vue?vue&type=script&lang=js"
export * from "./VHEWABOY.vue?vue&type=script&lang=js"
import style0 from "./VHEWABOY.vue?vue&type=style&index=0&id=55fd4c8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fd4c8d",
  null
  
)

export default component.exports